import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  negativeKeywordsListSection: {
    marginTop: 16
  }
})

export default useStyles
